import React from 'react';
import PropTypes from 'prop-types';

const ProductPageSkeleton = ({ isMobile, type }) => {
  let reactElement = null;
  switch (type) {
    case 'gallery':
      reactElement = <div className="l-grid__unit c-product-page__container c-product-page__container--image">
        <div className="c-product-page__skeleton-container--row">
          <img
            className={`c-product-page__skeleton--thumbnails c-product-page__skeleton--loading ${isMobile ? 'c-product-page__skeleton--hide' : ''
              }`}
          />
          <img
            className={`c-product-page__skeleton--main c-product-page__skeleton--loading ${isMobile ? 'c-product-page__skeleton--main-mobile' : ''
              }`}
          />
        </div>
      </div>
      break;
    case 'swatches':
      reactElement = <div className="c-product-page__skeleton--style-colours c-product-page__skeleton--loading" />
      break;
    case 'sizeSelector':
      reactElement = <div className="c-product-page__skeleton--size-selector c-product-page__skeleton--loading" />
      break;
    case 'accessories':
      reactElement = <div className="c-product-page__skeleton--accessories c-product-page__skeleton--loading" />
      break;
    default: 
      reactElement = null;
      break;
  }
  
  return (reactElement);
};

ProductPageSkeleton.propTypes = {
  isMobile: PropTypes.bool,
};

export default ProductPageSkeleton;
